const loadingHOCStyle = {
  spinner: {
    display: "block",
    margin: "2em auto",
    animation: "$rotation 2s infinite linear"
  },
  fixedSpinner: {
    position: "absolute",
    top: "50%",
    left: "50%",
    zIndex: "100000",
    animation: "$rotation 2s infinite linear"
  },
  "@keyframes rotation ": {
    from: { transform: "rotate(0deg)" },
    to: { transform: "rotate(360deg)" }
  }
};

export default loadingHOCStyle;
